import React, { useMemo } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import logo from "../assets/refex_logo.webp";
import "../styles/SideBar.css";

export const moduleRouteMap = {
  LIVE: {
    path: "/live",
    icon: (
      <svg
        width="20"
        height="21"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M14 16H9m11 0h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2h-1M5 16H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h1m5-4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" />
      </svg>
    ),
  },
  CONFIGURATION: {
    path: "/add-configuration",
    icon: (
      <svg
        width="20"
        height="21"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M14 16H9m11 0h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2h-1M5 16H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h1m5-4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" />
      </svg>
    ),
  },

};

export default function Sidebar({ isSidebarOpen = true }) {
  const location = useLocation();
  const navigate = useNavigate();

  const modules = useMemo(() => {
    const stored = localStorage.getItem("modules");
    return stored ? JSON.parse(stored) : [];
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login", { replace: true });
  };

  return (
    <div className={`sidebar ${isSidebarOpen ? "" : "collapsed"}`}>
      <div className="sidebar-header">
        <img src={logo} alt="Logo" className="sidebar-logo" />
      </div>

      <nav className="sidebar-menu">
        {modules.map((module) => {
          const config = moduleRouteMap[module.name];
          if (!config) return null; 

          return (
            <Link
              key={module.name}
              to={config.path}
              className={`sidebar-menu-item${
                location.pathname === config.path ? " active" : ""
              }`}
            >
              <span className="sidebar-icon">{config.icon}</span>
              <span className="sidebar-label">{module.name}</span>
            </Link>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        <button
          onClick={handleLogout}
          className="sidebar-menu-item sidebar-logout-btn"
        >
          <span className="sidebar-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
          </span>
          <span className="sidebar-label">Logout</span>
        </button>
      </div>
    </div>
  );
}
